import { Plot } from "@/components/Plotting/models/Plot";
import { PlottingJsonParsingInputType } from "@/components/Plotting/services/PlottingJsonParsingService";
import { IQueueExecutionCustomPlotsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { SchemaCoalesceService } from "./SchemaCoalesceService";


export class PlottingSchemaCoalesceService extends SchemaCoalesceService<Plot, PlottingJsonParsingInputType, IQueueExecutionCustomPlotsProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<Plot, PlottingJsonParsingInputType>): IQueueExecutionCustomPlotsProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const coalesceResult: IQueueExecutionCustomPlotsProp = {
            plots: parsingResult.parsedEntities ?? []
        };

        return coalesceResult;
    }

}
